<template>
  <div
    class="text-field-container"
    :class="{ hasDetails }"
  >
    <label class="form-label-text">
      {{ customLabel || label }}
    </label>
    <slot name="description" />
    <v-text-field
      v-bind="{ ...$props, ...$attrs }"
      class="multiline-error"
      flat
      variant="outlined"
      density="compact"
      color="brandPrimary"
      base-color="textDarkest"
      single-line
    >
      <slot />
      <template #append-inner>
        <slot name="append" />
      </template>
      <template #message="props">
        <slot
          name="message"
          v-bind="props"
        >
          {{ props.message }}
        </slot>
      </template>
    </v-text-field>
  </div>
</template>
<script>
export default {
  name: 'DpplTextField',
  props: {
    label: { type: String, default: '' },
    customLabel: { type: String, default: null },
    hasDetails: { type: Boolean, default: false },
  },
};
</script>
<style scoped lang="less">
.text-field-container {
  text-align: left;
  .multiline-error {
    white-space: pre-line;
  }
  :deep(.v-text-field) {
    margin-top: 4px;

    input{
      color: rgb(var(--v-theme-textDarkest));
      font-weight: 300;
    }
  }

  :deep(.v-field.v-field--error .v-label.v-field-label) {
    color: rgb(var(--v-theme-textDarkest));
  }
  :deep(.v-text-field .v-text-field__details) {
      margin-top: 4px;
      margin-bottom: 0;
      padding-left: 0;
    }

  :deep(.v-input__details) {
    padding-left: 0;
    // always hide error message container
    display: none;
  }
  // but show it if there's an error or hasDetails set to true
  .v-input--error, &.hasDetails {
    :deep(.v-input__details) {
      display: initial;
    }
  }
}

:deep(.v-field) .v-label {
  opacity: 1;
  color: rgb(var(--v-theme-textDarkest));
  font-weight: 300;
}
</style>
